module.exports = __webpack_public_path__ + "img/car_00058.b2a6e866.jpg";